import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../utils/common'
import Text from '../../../../Text'
import { RentalPortalListingObjectCell } from '../../../RentalPortalListingObjectCell'
import {
  QA_NAME_LISTING_DRAFT_SAVED_AT,
  QA_NAME_LISTING_DRAFT_UNIT,
  QA_NAME_LISTING_DRAFT_UNTITLED,
} from '../RentalPortalListingDraftCreateActionSelectModal.constants'
import {
  getListingDraftCoverPhoto,
  getListingDraftSavedAtLabel,
  getListingDraftUnitLabel,
} from '../RentalPortalListingDraftCreateActionSelectModal.utils'

import * as styles from './RentalPortalListingDraftCreateActionSelectModalOption.module.css'

function RentalPortalListingDraftCreateActionSelectModalOption({ draft }) {
  const { t } = useTranslation()

  const unitLabel = getListingDraftUnitLabel(draft)

  const savedAtLabel = getListingDraftSavedAtLabel(draft)

  const coverPhoto = getListingDraftCoverPhoto(draft)

  const unitValue = unitLabel ?? t('RentalPortal.ListingDraftUntitledKey')

  return (
    <>
      {t('RentalPortal.ListingDraftOpenActionKey')}
      <RentalPortalListingObjectCell
        photo={coverPhoto}
        qaName={
          unitLabel
            ? QA_NAME_LISTING_DRAFT_UNIT
            : QA_NAME_LISTING_DRAFT_UNTITLED
        }
        title={unitValue}
      />
      {savedAtLabel ? (
        <Text
          {...getQaSelector({ value: QA_NAME_LISTING_DRAFT_SAVED_AT })}
          isSecondary
          className={styles.savedAt}
        >
          {savedAtLabel}
        </Text>
      ) : null}
    </>
  )
}

export default RentalPortalListingDraftCreateActionSelectModalOption
